import { render, staticRenderFns } from "./p295_cartBtn.vue?vue&type=template&id=974e5faa"
import script from "./p295_cartBtn.vue?vue&type=script&lang=js"
export * from "./p295_cartBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports